import { render, staticRenderFns } from "./MusicName.vue?vue&type=template&id=07f54054&scoped=true&"
import script from "./MusicName.vue?vue&type=script&lang=js&"
export * from "./MusicName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f54054",
  null
  
)

export default component.exports